import { createFallbackField } from "./field-utils";
export class FieldRepository {
    constructor(fields = []) {
        this._fields = new Map(fields.map((field) => [field.key, field]));
    }
    register(fields) {
        fields.forEach((field) => {
            this._fields.set(field.key, field);
        });
    }
    find(key) {
        var _a;
        return (_a = this._fields.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    get(key) {
        const field = this._fields.get(key);
        if (field)
            return field;
        return createFallbackField(key);
    }
    has(key) {
        return this._fields.has(key);
    }
    getAll() {
        return Array.from(this._fields.values());
    }
}
